import React, { useCallback, useEffect, useState, useRef } from "react";
import { Row, Col } from 'react-bootstrap';
import Table from 'react-bootstrap/Table';
import { motion } from "framer-motion";

import Pagination from "../../../../../ui/Pagination";
import SkeletonLoader from "../../../../../ui/SkeletonLoader";
import NoDataFound from "../../../../../ui/NoDataFound";

import { searchIcon, trendingDownIcon, trendingUpIcon, tableSortArrowIcon } from "../../../../../../utils/icons";
import { formatNumber } from "../../../../../../utils/util";

import { useSelector, useDispatch } from 'react-redux';
import { getVendorRiskProfile, resetVendorRiskProfile } from "../../../../../../store/actions/thirdPartyRiskAction";

const VendorOverview = ({customerId}) => {

    const vendorRiskProfileListResponse = useSelector((state) => state.thirdPartyRisk.vendorRiskProfileList);

    const prevCustomerIdRef = useRef(null);
    
    const dispatch = useDispatch();

    const [searchValue, setSearchValue] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [currentPageSize, setCurrentPageSize] = useState(10);

    const [vendorRiskProfileList, setVendorRiskProfileList] = useState([]);
    const [isLoading, setIsLoading] = useState(false)
    const [paginatedData, setPaginatedData] = useState([]);
    const [sortColumn, setSortColumn] = useState(null);
    const [sortDirection, setSortDirection] = useState("asc");

    const setCurrentPageandRecordSize = (currentPage, pageSize) => {
        setCurrentPage(currentPage);
        if(pageSize !== currentPageSize) {
            setCurrentPageSize(pageSize);
            setCurrentPage(1);
        }
    }

    const handleSort = (columnKey) => {
        if (sortColumn === columnKey) {
            // Toggle direction
            setSortDirection(prev => (prev === "asc" ? "desc" : "asc"));
        } else {
            // New column, default to ascending
            setSortColumn(columnKey);
            setSortDirection("asc");
        }
    };

    const extractValue = (obj, key) => {
        const keyMap = {
            cves: obj?.stats?.cve_count || 0,
            takeoverRisk: obj?.stats?.subdomain_takeover_count || 0,
            compromised: obj?.stats?.compromised_ip_count || "",
            blacklisted: obj?.stats?.blacklisted_ip_count || 0,
            certificate: obj?.stats?.expired_certificate_count || 0,
            credentials: obj?.stats?.leaked_credential_count || 0,
            botnet: obj?.stats?.botnet_leak_count || 0,
            ssl: obj?.stats?.ssl_vulnerability_count || 0,
            ransomeware: obj?.stats?.ransomware_group_leak_count || 0,
        };
    
        return keyMap[key] !== undefined ? keyMap[key] : obj?.[key] || "";
    };

    const fetchVendorRiskProfile = useCallback(()=>{
        setIsLoading(true)
        dispatch(getVendorRiskProfile(customerId))
    },[customerId, dispatch])

    useEffect(()=>{
        if(customerId !== prevCustomerIdRef.current) {
            fetchVendorRiskProfile();
            prevCustomerIdRef.current = customerId;
        }
    },[customerId, fetchVendorRiskProfile])

    useEffect(() => {
        let filtered = vendorRiskProfileList?.length > 0 ? [...vendorRiskProfileList] : [];

        if (searchValue.trim()) {
            filtered = filtered.filter((org) =>
                org.name.toLowerCase().includes(searchValue.toLowerCase())
            );
        }

        if (sortColumn) {
            filtered.sort((a, b) => {
                const aVal = extractValue(a, sortColumn);
                const bVal = extractValue(b, sortColumn);
    
                if (typeof aVal === "string") {
                    return sortDirection === "asc"
                        ? aVal.localeCompare(bVal)
                        : bVal.localeCompare(aVal);
                } else {
                    return sortDirection === "asc"
                        ? aVal - bVal
                        : bVal - aVal;
                }
            });
        }

        const startIndex = (currentPage - 1) * currentPageSize;
        const endIndex = startIndex + currentPageSize;
        setPaginatedData(filtered.slice(startIndex, endIndex));

    }, [vendorRiskProfileList, searchValue, currentPage, currentPageSize, sortColumn, sortDirection]);

    useEffect(() => {
        setCurrentPage(1);
    }, [searchValue]);

    useEffect(()=>{
        if(vendorRiskProfileListResponse !== null) {
            const orgs = vendorRiskProfileListResponse?.stats?.organizations;
            setVendorRiskProfileList(orgs);
            dispatch(resetVendorRiskProfile())
            setIsLoading(false)
        }
    },[vendorRiskProfileListResponse, dispatch])
    
    return (
        <Row>
            <Col lg={12}>
                <div className="git-leaks-main-content third-party-overview bg-white-with-shadow p-4 mt-4">
                    <p className="heading-text mb-3">Vendor Risk Profile</p>
                    <div className="search-header-container d-flex align-items-center gap-3">
                        <div className="d-flex gap-3">
                            <div className="search-container position-relative">
                                <span className="position-absolute">{searchIcon()}</span>
                                <input type="text" 
                                    placeholder="Search" 
                                    value={searchValue} 
                                    onChange={(e)=>setSearchValue(e.target.value)} />
                            </div>
                            {/* <button className="search-btn">Search</button> */}
                        </div>                    
                        {/* <div className="position-relative">
                            <span className="filter-icon">{filterIcon()}</span>
                            {isAnyFilterActive && (<span className="reset-filter-link" onClick={resetFilterValue}>Reset Filter</span>)}
                            {showFilter && <div className="filters-container position-absolute p-3 rounded" ref={filterWrapperRef}>
                                <h6>New Findings</h6>
                                <div className="filter-user-status d-flex mb-4 gap-4">
                                    {
                                        newFindingsOption.map((data,index)=>{
                                            return (
                                                <RadioButton radioId={data.label + index} radioValue={data.value} radioLabel={data.label} onChange={(value)=>{setNewFindingsType(value)}} key={index} isChecked={data.value === newFindingsType} />
                                            )
                                        })
                                    }
                                </div>
                                {getloggedInUserType() === "internal" && <>
                                    <h6>False Positive</h6>
                                    <div className="filter-user-status d-flex mb-4 gap-4">
                                        {
                                            newFindingsOption.map((data,index)=>{
                                                return (
                                                    <RadioButton radioId={`false-positive-${index}`} radioValue={data.value} radioLabel={data.label} onChange={(value)=>{setSelectedFalsePositive(value)}} key={index} isChecked={data.value === selectedFalsePositive} />
                                                )
                                            })
                                        }
                                    </div>
                                </>}                            
                                <h6>Status</h6>
                                <div className="filter-user-status d-flex mb-4 gap-4">
                                    {
                                        statusOption.map((data,index)=>{
                                            return (
                                                <RadioButton radioId={data.label + index} radioValue={data.value} radioLabel={data.label} onChange={(value)=>{setStatusSelected(value)}} key={index} isChecked={data.value === statusSelected} />
                                            )
                                        })
                                    }
                                </div>
                                <div className="filter-apply-btn mt-3">
                                    <Button buttonText={"Apply"}  buttonType={"primary"} disableButton={newFindingsType === "" && statusSelected === "" && selectedFalsePositive === ""} buttonClicked={()=>{applyFilter()}}/>
                                </div>
                            </div>}
                        </div> */}
                    </div>
                    <div className="table-container js-secrets-table vendor-risk-profile-table mt-3">
                        {
                            isLoading ?
                                <SkeletonLoader type={"line"} count={5} currentPage={"dashboardOverview"} />
                            :
                            <Table>
                                <thead>
                                    <tr>
                                        <th>Vendor Organization</th>
                                        <th><p className="d-flex align-items-center cursor-pointer gap-2"><span className="d-inline-block" onClick={() => handleSort("cves")}>Critical CVEs</span><span className="d-inline-block">{tableSortArrowIcon()}</span></p></th>
                                        <th><p className="d-flex align-items-center cursor-pointer gap-2"><span className="d-inline-block" onClick={() => handleSort("takeoverRisk")}>Subdomain takeover Risks</span><span className="d-inline-block">{tableSortArrowIcon()}</span></p></th>
                                        {/* <th><p className="d-flex align-items-center cursor-pointer gap-2"><span className="d-inline-block" onClick={() => handleSort("compromised")}>Compromised IPs</span><span className="d-inline-block">{tableSortArrowIcon()}</span></p></th> */}
                                        <th><p className="d-flex align-items-center cursor-pointer gap-2"><span className="d-inline-block" onClick={() => handleSort("blacklisted")}>Blacklisted IPs</span><span className="d-inline-block">{tableSortArrowIcon()}</span></p></th>
                                        {/* <th><p className="d-flex align-items-center cursor-pointer gap-2"><span className="d-inline-block" onClick={() => handleSort("certificate")}>Certificates Expired</span><span className="d-inline-block">{tableSortArrowIcon()}</span></p></th> */}
                                        <th><p className="d-flex align-items-center cursor-pointer gap-2"><span className="d-inline-block" onClick={() => handleSort("credentials")}>Credentials Leak</span><span className="d-inline-block">{tableSortArrowIcon()}</span></p></th>
                                        <th><p className="d-flex align-items-center cursor-pointer gap-2"><span className="d-inline-block" onClick={() => handleSort("botnet")}>Botnet Leaks</span><span className="d-inline-block">{tableSortArrowIcon()}</span></p></th>
                                        <th><p className="d-flex align-items-center cursor-pointer gap-2"><span className="d-inline-block" onClick={() => handleSort("ssl")}>SSL Vulnerabilities</span><span className="d-inline-block">{tableSortArrowIcon()}</span></p></th>
                                        <th><p className="d-flex align-items-center cursor-pointer gap-2"><span className="d-inline-block" onClick={() => handleSort("ransomeware")}>Ransomeware Leaks</span><span className="d-inline-block">{tableSortArrowIcon()}</span></p></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        paginatedData?.length > 0 &&
                                        paginatedData.map((data, index)=>{
                                            return (
                                                <motion.tr
                                                    key={index}
                                                    initial={{ opacity: 0, y: 20 }}
                                                    animate={{ opacity: 1, y: 0 }}
                                                    transition={{ duration: 0.4, delay: index * 1 }}
                                                >
                                                    <td className="vendor-details">
                                                        <p className="vendor-name">{data?.name}</p>
                                                        <p className="vendor-date">{formatNumber(data?.stats?.overall_score?.obtained_score)} | {data?.stats?.overall_score?.percentage}%  <span>{data?.stats?.overall_score?.trend === "decreased" ? trendingDownIcon() : trendingUpIcon()}</span></p>
                                                    </td>
                                                    <td>
                                                        {formatNumber(data?.stats?.cve_count)}
                                                    </td>
                                                    <td>
                                                        {formatNumber(data?.stats?.subdomain_takeover_count)}
                                                    </td>
                                                    {/* <td>
                                                        {formatNumber(data?.stats?.compromised_ip_count)}
                                                    </td> */}
                                                    <td>
                                                        {formatNumber(data?.stats?.blacklisted_ip_count)}
                                                    </td>
                                                    {/* <td>
                                                        {formatNumber(data?.stats?.expired_certificate_count)}
                                                    </td> */}
                                                    <td>
                                                        {formatNumber(data?.stats?.leaked_credential_count)}
                                                    </td>
                                                    <td>
                                                        {formatNumber(data?.stats?.botnet_leak_count)}
                                                    </td>
                                                    <td>
                                                        {formatNumber(data?.stats?.ssl_vulnerability_count)}
                                                    </td>
                                                    <td>
                                                        {formatNumber(data?.stats?.ransomware_group_leak_count)}
                                                    </td>
                                                </motion.tr>
                                            )
                                        })
                                    }                                    
                                </tbody>
                            </Table>
                        }
                        
                        {!isLoading && vendorRiskProfileList?.length > 0 && <Pagination
                            className="pagination-bar"
                            currentPage={currentPage}
                            pageSize={currentPageSize}
                            totalCount={
                                searchValue.trim()
                                    ? vendorRiskProfileList.filter(org => org.name.toLowerCase().includes(searchValue.toLowerCase())).length
                                    : vendorRiskProfileList.length
                            }
                            onPageChange={setCurrentPageandRecordSize}
                        />}
                        {((!isLoading && vendorRiskProfileList?.length === 0) || vendorRiskProfileList === undefined) && 
                            <motion.div
                                initial={{ opacity: 0, y: 20 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.4 }}
                            >
                                <NoDataFound noDataText={"No Record Found"}/>
                            </motion.div>
                        }
                    </div>
                </div>
            </Col>
        </Row>
    )
}

export default VendorOverview;